module.exports = __webpack_public_path__ + "static/media/typing_details.6c9cf49a.svg";